/**
 * SPA 内部遷移のヘルパ。
 *
 * 旧コードは `window.location.href = '/...'` で hard navigation していて、
 * 遷移ごとに HTML / 主バンドル / WASM (1.1MB+) が再 fetch されていた。
 * `navigate()` 経由なら `history.pushState` で URL を切り替えるだけで済む
 * (App.tsx の popstate listener が route を再パースする)。
 *
 * 外部 URL / ダウンロード / ログイン経路 (SPA route が無い) は対象外。
 */

/** pushState で URL を切り替えて App に route 再パースを促す。 */
export function navigate(to: string): void {
  if (typeof window === 'undefined') return;
  if (window.location.pathname + window.location.search === to) return;
  window.history.pushState({}, '', to);
  // App.tsx の popstate listener が再パースして setRoute する。
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/** replaceState 版。 履歴を残さない (= 戻るボタンで unknown route に戻さない、 等)。 */
export function navigateReplace(to: string): void {
  if (typeof window === 'undefined') return;
  window.history.replaceState({}, '', to);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/** `<a href="/...">` の onClick として渡せる helper。 修飾キー (cmd-click 等) は通常動作に任せる。 */
export function onLinkClick(to: string): (e: React.MouseEvent<HTMLAnchorElement>) => void {
  return (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };
}
